jQuery(document).ready(function ($) {
    $(document).on('submit', '#resource-download-form', function (e) {
        document.cookie = "resourceNonce=1; path=/; max-age=" + (60 * 60 * 24 * 7);
    });

    $(document).on('facetwp-loaded', function () {
        let searchVal = FWP.facets['search']; // 'search' = your facet name

        let searchHeader = $('.wbcsd-search-header h1.search-title');

        if (searchVal && searchVal.length > 0) {
            let titleHTML = 'You searched for: <em>' + searchVal + '</em>';
            searchHeader.html(titleHTML);
        } else {
            searchHeader.text(searchHeader.data('base-title'));
        }
    });

    $(document).on('facetwp-loaded', function () {
        if (FWP.loaded) { // Run only after the initial page load
            $('html, body').animate({
                scrollTop: $('.facetwp-template').offset().top - 250 // Scroll to the top of the element with class "facetp-template"
            }, 500);
        }
    });
});